import { DatePipe, CurrencyPipe, PercentPipe, DecimalPipe, AsyncPipe } from '@angular/common';

import { MomentDatetimePipe } from './moment-datetime.pipe';
import { UserFullNamePipe } from './person-full-name';

/** Pipes global providers. */
// Needed for use in custom pipes.
export const pipesProviders = [DatePipe, CurrencyPipe, PercentPipe, DecimalPipe, AsyncPipe, MomentDatetimePipe, UserFullNamePipe];
